export const scrollToHash = (hash) => {
  const id = hash.replace("#", "");
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.1 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const handleAnchorClick = (e, hash) => {
  e.preventDefault();
  if (window.location.pathname !== "/") {
    window.location.assign(`/${hash}`);
    return;
  }
  scrollToHash(hash);
  window.history.replaceState(null, "", hash);
};
